module.exports = __webpack_public_path__ + "img/honour-pic-7.3b850606.png";